import api from './api';

// A translate run is synchronous — one full email per selected language through an LLM at up to 3
// concurrent calls — so it needs far more than the default axios timeout.
const TRANSLATE_TIMEOUT_MS = 5 * 60 * 1000;

export const crmEmailAPI = {
  // The action's default-language content plus the languages a run may target
  getEmail: (automationId, actionId) =>
    api.get('/api/crm-email/email', { params: { automation_id: automationId, action_id: actionId } }),

  // Translates into every listed language and publishes each to Customer.io; per-language
  // outcomes come back in the response
  translate: (body) =>
    api.post('/api/crm-email/translate', body, { timeout: TRANSLATE_TIMEOUT_MS }),
};

export default crmEmailAPI;
